import React, { useCallback } from 'react';

import { FlexRow } from '@editor/components/utilities/layouts';
import MemberIcon from '@repo/ui/components/Icon/MemberIcon';
import { H5, P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import Select from '../../SelectNew/Select';

import { MemberOption, MemberSelectProps } from './types';

const options: MemberOption[] = Array.from(Array(50).keys()).map((_, index) => {
  const members = index + 1;
  return {
    id: members,
    label: `${members} Member${members === 1 ? '' : 's'}`,
  };
});

const MemberSelect: React.FC<MemberSelectProps> = ({
  selectedNumberOfMembers,
  onSelect,
}) => {
  const activeOption = options.find(({ id }) => id === selectedNumberOfMembers);

  const renderItem = useCallback(
    ({ label }: MemberOption, isController?: boolean) => {
      if (isController) {
        return (
          <FlexRow alignItems="center" gap="7px">
            <MemberIcon height="15px" />
            <P2>{label}</P2>
          </FlexRow>
        );
      }
      return (
        <H5 color={themeStyle.varInkMedium} style={{ padding: '0 6px' }}>
          {label}
        </H5>
      );
    },
    []
  );

  const handleSelect = useCallback(
    ({ id }: MemberOption): void => {
      onSelect(id);
    },
    [onSelect]
  );

  return (
    <Select
      activeOption={activeOption}
      optionCustomStyles={{
        padding: '6px',
      }}
      options={options}
      renderItem={renderItem}
      onSelect={handleSelect}
    />
  );
};

export default MemberSelect;
